import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { EventOutlined, EventAvailableOutlined } from '@mui/icons-material'
import { formatDateByUserTimeZone } from '../../../helpers/formatDateByUserTimeZone'

interface NextEmailSendRowProps {
  isSlotPublishedOrLater: boolean
  isEnabled: boolean
  nextEmailPushTimestamp?: string | null
  lastEmailSentTimestamp?: string | null
}

const DATE_FORMAT = 'MMMM d, yyyy h:mm a z'

export function NextEmailSendRow ({
  isSlotPublishedOrLater,
  isEnabled,
  nextEmailPushTimestamp,
  lastEmailSentTimestamp
}: NextEmailSendRowProps): JSX.Element | null {
  if (!isEnabled || !isSlotPublishedOrLater) return null

  const hasNext = nextEmailPushTimestamp != null
  const hasLast = lastEmailSentTimestamp != null

  if (!hasNext && !hasLast) return null

  return (
    <Stack spacing={1}>
      {hasNext && (
        <Box display="flex" alignItems="center" gap={1}>
          <EventOutlined fontSize="small" color="action" />
          <Typography variant="p5" color="text.secondary">
            Next send: {formatDateByUserTimeZone(nextEmailPushTimestamp, DATE_FORMAT)}
          </Typography>
        </Box>
      )}
      {hasLast && (
        <Box display="flex" alignItems="center" gap={1}>
          <EventAvailableOutlined fontSize="small" color="action" />
          <Typography variant="p5" color="text.secondary">
            Last sent: {formatDateByUserTimeZone(lastEmailSentTimestamp, DATE_FORMAT)}
          </Typography>
        </Box>
      )}
    </Stack>
  )
}
